import { render, staticRenderFns } from "./ArchivedSales.vue?vue&type=template&id=2fa08e10&scoped=true&"
import script from "./ArchivedSales.vue?vue&type=script&lang=js&"
export * from "./ArchivedSales.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedSales.vue?vue&type=style&index=0&id=2fa08e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa08e10",
  null
  
)

export default component.exports